<template>
    <div>
        <el-row style="margin: auto;">
            <!--        产品库下拉选择-->
            <el-col :xs="14" :sm="9" :md="9" :lg="7" :xl="7" style="margin-left: 50px;margin-bottom: 50px">
                <div>
                    <el-select v-model="biaotou_id" size="medium "
                               class="sousuo_list" style="color: #9e9e9e ;">
                        <el-option v-for="item in biaotou1"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.name"></el-option>
                    </el-select>
                    <el-button type="danger" class="sousuo_list1" @click="xianshi_table">
                        分类
                    </el-button>
                </div>
            </el-col>
            <!-- 第一个搜索框-->
            <el-col :xs="14" :sm="9" :md="9" :lg="7" :xl="7" style="margin-left:-50px;">
                <div class="zhuhe_list">
                    <el-input v-model="sousuo" size="small" class="input-with-select">
                        <el-select slot="prepend" v-model="select" class="xujz">
                            <el-option label="货物名称" value="name"></el-option>
                            <el-option :label="toulist[0].key" :value="toulist[0].id">{{toulist[0].key}}</el-option>
                            <el-option :label="toulist[1].key" :value="toulist[1].id">{{toulist[1].key}}</el-option>
                            <el-option :label="toulist[2].key" :value="toulist[2].id">{{toulist[2].key}}</el-option>
                            <el-option :label="toulist[3].key" :value="toulist[3].id">{{toulist[3].key}}</el-option>
                            <el-option :label="toulist[4].key" :value="toulist[4].id">{{toulist[4].key}}</el-option>
                            <el-option :label="toulist[5].key" :value="toulist[5].id">{{toulist[5].key}}</el-option>
                        </el-select>
                        <el-button slot="append" @click="xianshi_table(sousuo,currentPage)">搜索</el-button>
                    </el-input>
                </div>
            </el-col>
            <!--               第二个搜索框-->
            <el-col :xs="14" :sm="9" :md="9" :lg="7" :xl="7" style="margin-left: 100px">
                <div class="zhuhe_list">
                    <el-input v-model="sousuo1" size="small" class="input-with-select">
                        <el-select slot="prepend" v-model="select1" class="xujz">
                            <el-option label="货物名称" value="name"></el-option>
                            <el-option :label="toulist[0].key" :value="toulist[0].id">{{toulist[0].key}}</el-option>
                            <el-option :label="toulist[1].key" :value="toulist[1].id">{{toulist[1].key}}</el-option>
                            <el-option :label="toulist[2].key" :value="toulist[2].id">{{toulist[2].key}}</el-option>
                            <el-option :label="toulist[3].key" :value="toulist[3].id">{{toulist[3].key}}</el-option>
                            <el-option :label="toulist[4].key" :value="toulist[4].id">{{toulist[4].key}}</el-option>
                            <el-option :label="toulist[5].key" :value="toulist[5].id">{{toulist[5].key}}</el-option>
                        </el-select>
                        <el-button slot="append" @click="xianshi_table('',currentPage,sousuo1)">二次搜索</el-button>
                    </el-input>
                </div>
            </el-col>
        </el-row>

        <!-- 列表展示-->
        <div class="biaoge_list">
<!--            <div class="main-backgrounds-middle biao_list ">-->
<!--                <div class="main-backgrounds-middle-title xianshi" style="margin-left:30px">序号</div>-->
<!--                <div class="main-backgrounds-middle-title xianshi" style="margin-left:-15px">货物名称</div>-->
<!--                <div class="main-backgrounds-middle-title  xianshi" style="margin-left:-10px" :title="toulist[0].key">-->
<!--                    {{toulist[0].key}}-->
<!--                </div>-->
<!--                <div class="main-backgrounds-middle-title xianshi" style="margin-left: 10px" :title="toulist[1].key">-->
<!--                    {{toulist[1].key}}-->
<!--                </div>-->
<!--                <div class="main-backgrounds-middle-title xianshi" style="margin-left:10px" :title="toulist[2].key">-->
<!--                    {{toulist[2].key}}-->
<!--                </div>-->
<!--                <div class="main-backgrounds-middle-title xianshi" style="margin-left:-10px" :title="toulist[3].key">-->
<!--                    {{toulist[3].key}}-->
<!--                </div>-->
<!--                <div class="main-backgrounds-middle-title xianshi" style="margin-left:10px" :title="toulist[4].key">-->
<!--                    {{toulist[4].key}}-->
<!--                </div>-->
<!--                <div class="main-backgrounds-middle-title xianshi" style="margin-left:-10px" :title="toulist[5].key">-->
<!--                    {{toulist[5].key}}-->
<!--                </div>-->
<!--                <div class="main-backgrounds-middle-title xianshi" style="margin-right:15px">关联说明</div>-->
<!--                <div class="main-backgrounds-middle-title xianshi" style="margin-right: -20px">价格</div>-->
<!--            </div>-->
            <!--            内容-->
            <div>
                <el-table border :data="list">
                    <!--   序号   @cell-click="tabClick"-->
                    <el-table-column property="date" width="100">
                        <template #header>序号</template>
                        <template slot-scope="{$index}">
                            <div style="text-align: center">
                                {{ $index + (currentPage -1) * PageSize + 1 }}
                            </div>
                        </template>
                    </el-table-column>
                    <!--名称-->
                    <el-table-column>
                        <template #header>货物名称</template>
                        <template slot-scope="scope">
                            <div style="text-align: center">
                                {{ scope.row.name}}
                            </div>
                        </template>
                    </el-table-column>
                    <!-- 规格描述-->
                    <span v-if="toulist[0].show == false"></span>
                    <el-table-column v-else>
                        <template #header>{{toulist[0].key}}</template>
                        <template slot-scope="scope">
                            <div style="text-align: center">
                                {{ scope.row.attr_values['162']}}
                            </div>
                        </template>
                    </el-table-column>
                    <!-- 货号  -->
                    <sapn v-if="toulist[1].show == false"></sapn>
                    <el-table-column v-else>
                        <template #header>{{toulist[1].key}}</template>
                        <template slot-scope="scope">
                            <div style="text-align: center">
                                {{ scope.row.attr_values['163']}}
                            </div>
                        </template>
                    </el-table-column>
                    <!-- 品牌 -->
                    <span v-if="toulist[2].show == false"></span>
                    <el-table-column v-else prop="attr_values['164']">
                        <template #header>{{toulist[2].key}}</template>
                        <template slot-scope="scope">
                            <span v-for="(item,index) in scope.row.attr_values['164']" v-bind:key="index">
                                <div v-if="scope.row.attr_values['164']==''">
                                    {{item}}
                                </div>
                                <div v-else style="border: #4E6EF2 solid 1px;border-radius: 3px;margin-top: 5px;text-align: center">
                                    {{item}}
                                </div>
                            </span>
                        </template>
                    </el-table-column>
                    <!-- 配套仪器 -->
                    <span v-if="toulist[3].show == false"></span>
                    <el-table-column v-else prop="attr_values['165']">
                        <template #header>{{toulist[3].key}}</template>
                        <template slot-scope="scope">
                            <span v-for="(item,index) in scope.row.attr_values['165']" v-bind:key="index">
                                <div v-if="scope.row.attr_values['165']==''">
                                    {{item}}
                                </div>
                                <div v-else style="border: #4E6EF2 solid 1px;border-radius: 3px;margin-top: 5px;text-align: center">
                                    {{item}}
                                </div>
                            </span>
                        </template>
                    </el-table-column>
                    <!-- 标准号 -->
                    <span v-if="toulist[4].show == false"></span>
                    <el-table-column v-else prop="attr_values['166']">
                        <template #header>{{toulist[4].key}}</template>
                        <template slot-scope="scope">
                            <span v-for="(item,index) in scope.row.attr_values['166']" v-bind:key="index">
                                <div v-if="scope.row.attr_values['166']==''">
                                    {{item}}
                                </div>
                                <div v-else style="border: #4E6EF2 solid 1px;border-radius: 3px;margin-top: 5px;text-align: center">
                                    {{item}}
                                </div>
                            </span>
                        </template>
                    </el-table-column>
                    <!--功能/故障说明-->
                    <span v-if="toulist[5].show == false"></span>
                    <el-table-column v-else prop="attr_values['167']">
                        <template #header>{{toulist[5].key}}</template>
                        <template slot-scope="scope">
                            <span v-for="(item,index) in scope.row.attr_values['167']" v-bind:key="index">
                                <div v-if="scope.row.attr_values['167']==''">
                                    {{item}}
                                </div>
                                <div v-else style="border: #4E6EF2 solid 1px;border-radius: 3px;margin-top: 5px;text-align: center">
                                    {{item}}
                                </div>
                            </span>
                        </template>
                    </el-table-column>
                    <!-- 关联说明-->
                    <el-table-column>
                        <template #header>关联说明</template>
                        <template slot-scope="scope">
                            <div v-for="(item,index) in list" :key="index">
                                <div v-for="(item1,index1) in item.star_light" :key="index1">
                                    <a :href="'#/dianpu_ligs/' + item1.id">
                                        <span v-if="item1.ware_id == scope.row.id">
                                            {{ item1.title }}
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <!-- 价格 -->
                    <el-table-column  prop="attr_values['168']">
                        <template #header>价格</template>
                        <template slot-scope="scope">
                            <span v-for="(item,index) in scope.row.attr_values['168']" v-bind:key="index">
                                <div v-if="scope.row.attr_values['168']==''">
                                    {{item}}
                                </div>
                                <div v-else style="border: #4E6EF2 solid 1px;border-radius: 3px;
                                    margin-top: 5px;text-align: center">
                                    {{item}}
                                </div>
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!--        分页-->
        <div data-v-6af373ef="" data-v-5c2776a4="" class="pagination-container"
             style="line-height: 5.1em;margin-top: 20px">
            <span class="el-pagination__total">共{{zongshu}}条</span>
            <el-pagination
                    style="float: left"
                    layout="prev, pager, next"
                    @current-change="yedianji"
                    :total="zuidayema*10"
                    class="ul-pagination">
            </el-pagination>

        </div>
    </div>
</template>

<script>
  export default {
    name: "chanpinku_info",
    data: function () {
      return {
        zongshu: '',
        zuidayema: '',
        list_zhanshi: [],
        list: [],
        xiaoxing: [],// 关联小星点灯
        list2: [],
        arr: [],
        arr1: [],
        arr2: [],
        arr3: [],
        biaotou1: [],
        biaotou111: [],
        arrlist: [],
        biaotou_id: this.nav_id,
        select: '',
        sousuo: '',
        sousuo1: '',
        select1: '',
        toulist: [
          {key: '规格描述', id: 162},
          {key: '货号', id: 163},
          {key: '品牌', id: 164},
          {key: '配套仪器(厂家、型号)', id: 165},
          {key: '适用标准号', id: 166},
          {key: '功能故障说明', id: 167},
          {key: '价格', id: 168},
        ],
        toulistcopy: [
          {key: '规格描述', id: 162},
          {key: '货号', id: 163},
          {key: '品牌', id: 164},
          {key: '配套仪器(厂家、型号)', id: 165},
          {key: '适用标准号', id: 166},
          {key: '功能故障说明', id: 167},
          {key: '价格', id: 168},
        ],
        currentPage: 1,//当前页数
        PageSize: 10,//每页显示的条数
          gg_table:'',//规格描述
          hh_table:'',//货号
          pp_table:'',//品牌
          pt_table:'',//配套仪器
          sy_table:'',//适用标准号
          gn_table:'',//功能故障说明
      }

    },
    props: ['nav_uid','nav_id'],
    methods: {
      // replace换行
      change(a) {
        if (a != null) {
          a = a.replace(/,/g, ";</br>")
          a = a.replace(/，/g, "；</br>");
          return a;
        }
      },
      // 关联小星点灯
      diandeng_list() {
        var t = this;
        var id = localStorage.getItem("uid")
        var url = window.config.api_url + '/user/shop/light/list?token=' + id
        t.axios.get(url).then(res => {
          t.xiaoxing = res.data.list.data
        })
      },
      title_list() {
        let t = this;
        let url = window.config.api_url + '/college/ware/house/list?uid=' + this.nav_uid
        t.axios.get(url).then(res => {
          t.biaotou1 = res.data;
          if (t.biaotou_id == '') {
            //如果没有选择了，就调用这个
            if (res.data[0].attr != null) {
              t.toulist = JSON.parse(res.data[0].attr)

            } else {
              t.list = JSON.parse(JSON.stringify(t.toulistcopy));
            }
          } else {
            res.data.forEach(item => {
              if (item.name == t.biaotou_id) {  //如果没有选择就调用这个
                if (item.attr != null) {
                  t.toulist = JSON.parse(item.attr);

                } else {
                  t.toulist = JSON.parse(JSON.stringify(t.toulistcopy));
                }
              }
            })
          }
          for (let i = 0; i < t.biaotou1.length; i++) {
            t.toulist = JSON.parse(t.gridData[i].attr)
          }

        })
      },
      yedianji(q) {
        this.xianshi_table('', q,'');
        this.currentPage = q;
      },
      xianshi_table(a, q,k) {
        let t = this;
        let url = ''
        if (a) {
          if (t.biaotou_id == '') {
            if (t.select == 'name') {
              url = window.config.api_url + '/college/ware/list?uid=' + this.nav_uid + '&name=' + a + '&page=' + q
            } else {
              url = window.config.api_url + '/college/ware/list?uid=' + this.nav_uid + '&attr_' + t.select + '=' + a + '&page=' + q
            }
          } else {
            if (t.select == 'name') {
              url = window.config.api_url + '/college/ware/list?uid=' + this.nav_uid + '&name=' + a + '&page=' + q
            } else {
              url = window.config.api_url + '/college/ware/list?uid=' + this.nav_uid + '&attr_' + t.select + '=' + a + '&page=' + q
            }
          }
        } else if (a,k) {
          if (t.biaotou_id == '') {
            if (t.select1 == 'name') {
              url = window.config.api_url + '/college/ware/list?uid=' + this.nav_uid  + '&name=' + a+k + '&page=' + q
            } else {
              url = window.config.api_url + '/college/ware/list?uid=' + this.nav_uid + '&attr_' +t.select1 + '=' + a+k +  '&page=' + q
            }
          } else {
            if (t.select1 == 'name') {
              url = window.config.api_url + '/college/ware/list?uid=' + this.nav_uid  + '&name=' +k+a + '&page=' + q
            } else {
              url = window.config.api_url + '/college/ware/list?uid=' + this.nav_uid +'&attr_' + t.select1 + '=' + k+a + '&page=' + q
            }
          }
        } else {
          if (t.biaotou_id == '') {
            url = window.config.api_url + '/college/ware/list?uid=' + this.nav_uid + '&house_name=' + t.biaotou1[0].name + '&page=' + q
          } else {
            url = window.config.api_url + '/college/ware/list?uid=' + this.nav_uid + '&house_name=' + t.biaotou_id + '&page=' + q
          }
        }
        t.axios.get(url).then(res => {
            console.log(res,1321313)
          t.list = res.data.data
            console.log(t.list,'t.list')
            // t.gg_table = [];
            // t.hh_table = [];
            // t.pp_table = [];
            // t.pt_table = [];
            // t.sy_table = [];
            // t.gn_table = [];
            // t.list.forEach(item=>{
            //     t.gg_table.push(JSON.parse(item.attr_values)[162]);
            //     t.hh_table.push(JSON.parse(item.attr_values)[163]);
            //     t.pp_table.push(JSON.parse(item.attr_values)[164]);
            //     t.pt_table.push(JSON.parse(item.attr_values)[165]);
            //     t.sy_table.push(JSON.parse(item.attr_values)[166]);
            //     t.gn_table.push(JSON.parse(item.attr_values)[167]);
            // });
            // console.log(t.gg_table,'t.gg_table')
            // console.log(t.hh_table,'t.gg_table')
            // console.log(t.pp_table,'t.gg_table')
            // console.log(t.pt_table,'t.gg_table')
            // console.log(t.sy_table,'t.gg_table')
            // console.log(t.gn_table,'t.gg_table')
            // console.log(t.hh_table == ''?'true':'false')
          t.zongshu = res.data.total
          t.zuidayema = res.data.last_page;//最大页面数
          t.list.forEach(item1=>{
            item1.attr_values=JSON.parse(item1.attr_values);
            //产品库价格从原来的单个改为多个，以的形式存储
            //原来price字段废弃，改为attr_values['168']字段
            //原来的price中的数据push进attr_values['168']字段中
            if(item1.price !=0){
              item1.attr_values['168']=[];
              item1.attr_values['168'].push(
                item1.price
              )
            }
          })
          this.title_list()
        })
      },
    },
    created() {
      this.diandeng_list();
      this.title_list();
      setTimeout(() => {
        this.xianshi_table();
      }, 1000)
    },
    // 监听下拉显示相关内容
    watch: {
      biaotou_id() {
        this.xianshi_table();
        this.currentPage = 1;
      },
    }
  }
</script>

<style lang="less">
    .main-backgrounds-middle {
        width: 100%;
        height: 60px;
        background-color: #FFF;
        overflow: hidden;
        margin-top: 15px;
        display: flex;
        justify-content: space-around;
        align-items: center;
    }

    .main-backgrounds-middle-title {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
    }

    /*.xianshi{*/
    /*    width: 10px*/
    /*}*/
    .biao_list {
        position: relative;
        top: 43px;
        z-index: 1;

    }
    .selet_list {
        /*margin-left: -100px ;*/
        width: 100px;
        height: 42px;
        position: relative;
        top: -42px;
        left: -88px;
        /*border-radius: 4px;*/
        color: #9e9e9e;
        border: 1px solid #409eff;
        border-radius: 3px;
        font-family: "方正兰亭中黑", "微软雅黑", Microsoft YaHei, Tahoma, Geneva, sans-serif;
    }

    .button_list {
        width: 70px;
        height: 42px;
        color: #f0f0f0;
        position: relative;
        top: -42px;
        left: 217px;
        background-color: #409eff;
        border: 2px solid #409eff;
    }
    .sousuo_list1 {
        position: relative;
        left: -3px;
    }

    .biaoge_list {
        position: relative;
        top: -60px;
        margin-top: 50px
    }

    .sousuo_list {
        .el-input--suffix .el-input__inner {
            width: 150px !important;
            height: 40px !important;
            background: #ffffff !important;
            border: 1px solid #f56c6c !important;
        }

    }


    /*组合框内容*/
    .zhuhe_list {

        .el-select .el-input {
            width: 100px;
        }

        .el-input__inner {
            border-top: 1px solid #4E6EF2;
            border-bottom: 1px solid #4E6EF2;
            border-left: none;
            border-right: none;
        }

        .input-with-select .el-input-group__prepend {
            background-color: #fff;
        }

        .el-input-group__append, .el-input-group__prepend {
            background-color: #4E6EF2;
            color: #FFFFFF;
            border: 1px solid #4E6EF2;
        }

        .xujz {
            .el-input__inner {
                color: #333333 !important;
            }
        }

        .el-input.is-active .el-input__inner, .el-input__inner:focus {
            border-color: #4E6EF2;
        }

        .el-input--small .el-input__inner {
            height: 46px;
        }

    }

</style>